import { useContext } from 'react';
import { ContexteToast, type Notifier } from './toast-context';

export function useToast(): Notifier {
  const notifier = useContext(ContexteToast);
  if (!notifier) {
    throw new Error('useToast doit être utilisé dans un FournisseurToasts');
  }
  return notifier;
}
